class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('focus', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      console.log('focusOut');
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    console.log('details-discloser 1');
    if (!this.animations) this.animations = this.content.getAnimations();
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    event.preventDefault();
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;
    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }
}
customElements.define('header-menu', HeaderMenu);



class HeaderMegaMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.mainMegaMenuDetailsToggle = this.querySelector('.megamenu details');
    this.mainMegaMenuDetailsToggle.addEventListener('mouseenter', this.onMegaMenuMouseEnter.bind(this));
    this.mainMegaMenuDetailsToggle.addEventListener('mouseleave', this.onMegaMenuMouseLeave.bind(this));
    this.timer = null;
  }

  onMegaMenuMouseEnter() {
    this.clearTimer();
    this.timer = setTimeout(() => {
      this.mainMegaMenuDetailsToggle.setAttribute('open', '');
      document.body.classList.add('megamenu-active');
    }, 250);
  }

  onMegaMenuMouseLeave() {
    this.clearTimer();
    this.timer = setTimeout(() => {
      document.body.classList.remove('megamenu-active');
      this.mainMegaMenuDetailsToggle.removeAttribute('open');
      this.mainMegaMenuDetailsToggle.querySelectorAll('.mega-menu__link--level-2.active').forEach(sib => sib.classList.remove('active'));
      this.mainMegaMenuDetailsToggle.querySelectorAll('.list-1--right .visible').forEach(sib => sib.classList.remove('visible'));
    }, 500)
  }

  clearTimer() {
    clearTimeout(this.timer);
  }
}
customElements.define('header-megamenu', HeaderMegaMenu);